import { roleHasPermission, type AppRole, type Permission } from "@order-analyzer/shared";
import { useAuth } from "../auth.js";

export function useHasPermission(permission: Permission): boolean {
  const { user } = useAuth();
  return (user?.roles ?? []).some((role) => roleHasPermission(role as AppRole, permission));
}

/** Wie useHasPermission, aber erlaubt bereits, wenn eine BELIEBIGE der übergebenen Berechtigungen vorliegt. */
export function useHasAnyPermission(permissions: Permission[]): boolean {
  const { user } = useAuth();
  return permissions.some((permission) => (user?.roles ?? []).some((role) => roleHasPermission(role as AppRole, permission)));
}

export function useHasRole(role: AppRole): boolean {
  const { user } = useAuth();
  return (user?.roles ?? []).includes(role);
}

/**
 * True, wenn der Benutzer AUSSCHLIESSLICH die Rolle "Business Manager" hat (keine weitere Rolle
 * wie z.B. Administrator). Für diese Benutzer zeigen Dashboard/Auswertungen ausschließlich die
 * eigenen Ziele/Themen/Umsätze (siehe /business-manager statt dem allgemeinen Dashboard).
 */
export function useIsOnlyBusinessManager(): boolean {
  const { user } = useAuth();
  const roles = user?.roles ?? [];
  return roles.length === 1 && roles[0] === "Business Manager";
}
